<template>
  <div>
  <navbar></navbar>
  <div class="app-body">
    <sidebar></sidebar>
    <!-- Main content -->
    <main class="main">
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </main>
  </div>
</div>
</template>
<script>
  import Navbar from './navbar'
  import Sidebar from './sidebar'
  export default {
    name: 'layout',
    components: {
      Navbar,
      Sidebar
    },
    computed: {
      classObject: function () {
        return {
          'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
          'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/layout.vue